export const PLAN_AVAILABILITY_NOTICE = {
  title: "Full Plans Available Soon",
  body: "We’re completing final launch setup. Your assessment results are available now, and personalized plans will be available shortly.",
};

export const canUserAccessPlanCheckout = (user) => Boolean(user?.can_access_plan_checkout);